// Images live here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview
export default {
  brandsList: [
    'air-heads',
    'american-express',
    'b-and-h-photo',
    'banana-republic',
    'benefit-cosmetics',
    'birchbox',
    'bose',
    'buzzfeed',
    'chase',
    'dermablend',
    'dollar-shave-club',
    'dr-brandt',
    'estee-lauder',
    'general-electric',
    'gopro',
    'it-cosmetics',
    'kate-spade',
    'oxygen',
    'lancome',
    'loreal',
    'make-up-for-ever',
    'mondelez',
    'oreo',
    'pandg',
    'pepperidge-farm',
    'revlon',
    'pepsi',
    'pureology',
    'shea-moisture',
    'swedish-fish',
    't-mobile',
    'under-armour',
    'viacom',
    'wish',
    'unilever',
    'zappos'
  ]
}



// WEBPACK FOOTER //
// ./client/store/brandLogosDictionary.js